export default "/img/SV.673d7579797dc102cf106ab1d6052037.png";